// eslint-disable-next-line
__webpack_public_path__ = window.appContextPath === '/' ? window.appContextPath : window.appContextPath + '/';

require('./setup.js');
